import React from 'react';
import Section from '../Section';
import SectionContents from 'views/services/SectionContents';

import styles from './Support.module.scss';
import SupportItems from './SupportItems';
import useGetTotalSubscribers from 'views/services/useGetTotalSubscribers';
import {getFormattedNumber} from 'utils/numbers';
import {LoadingText} from 'components/Loading';

function Index() {
  const {isLoading, data} = useGetTotalSubscribers();

  return (
    <Section mobilePad="top" className={styles['support']}>
      <SectionContents
        sizes={{xs: [12, 12]}}
        className={styles['support--contents']}
      >
        <div className={styles['support--header']}>
          <p className="mb-0">
            Trusted by{' '}
            {isLoading ? (
              <div className="mx-1 d-inline-block">
                <LoadingText isLoading />
              </div>
            ) : (
              <span>{getFormattedNumber(data)}</span>
            )}
            <span>&#43; Industry, Government & Regulator Users Worldwide</span>
          </p>
        </div>
        <SupportItems />
      </SectionContents>
    </Section>
  );
}

export default Index;
